export default "__VITE_ASSET__4a065a56__$_?component__"